export class AdditionalDetails
{
    address : string;
    zipCode: string;
    state: string;
    country:string;
    motherName:string;
    fatherName:string;
    parentEmail:string;
    parentContact:string;
}